import React from 'react'
import { Switch } from 'react-router-dom'
import { RouteWithPermission } from '../../../../../../_helper/routesWithPermission'
import { hasPermission } from '../../../../../../_helper/hasPermission'
import { permissions } from '../../../../../../_constants/permissions'
import TargetBehaviour from '../../../../../pages/admin/general/target'
import ReplacementBehaviour from '../../../../../pages/admin/general/replacement'
import { useSelector } from 'react-redux'

const BehaviorsIndexRoute  = () => {
    const auth = useSelector((state: { auth: any }) => state.auth);
    const userPermissions = auth.user.roleId;
  const canView = hasPermission(userPermissions, permissions.admin_billing_behavior_target_view)
  const canViewTarget = hasPermission(userPermissions, permissions.admin_billing_behavior_target_view)
  const canViewReplacement = hasPermission(userPermissions, permissions.admin_billing_behavior_replacement_view)

  return (  
    <Switch>
      <RouteWithPermission path='/admin/general/behavior/target' component={TargetBehaviour} hasPerm={(canView && canViewTarget)}/>
      <RouteWithPermission path='/admin/general/behavior/replacement' component={ReplacementBehaviour} hasPerm={(canView && canViewReplacement)}/>
    </Switch>
  )
}

export default BehaviorsIndexRoute